import { render, staticRenderFns } from "./purvenderrfq.vue?vue&type=template&id=1fe874c6&scoped=true&"
import script from "./purvenderrfq.vue?vue&type=script&lang=js&"
export * from "./purvenderrfq.vue?vue&type=script&lang=js&"
import style0 from "./purvenderrfq.vue?vue&type=style&index=0&id=1fe874c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe874c6",
  null
  
)

export default component.exports